export default [
  {
    name: 'Matching Maps',
    tagline: 'Stage 2',
    description: 'Which Maps Are The Same! - Pick the 2 Identical Maps',
    location: 'matching',
    instructions: [
      'You’ll see 4 small maps. They look the same but actually only 2 are. You need to pick those 2',
      'You get a point for each correct pair you get',
    ],
    recommendedGames: [2, 3],
    lockdown: true,
    practice: 'Junior',

    images: [
      '/matching/best/1.jpg',
      '/matching/best/2.jpg',
      '/matching/best/3.jpg',
      '/matching/best/4.jpg',
      '/matching/best/5.jpg',
      '/matching/best/6.jpg',
      '/matching/best/7.jpg',
      '/matching/best/8.jpg',
      '/matching/best/9.jpg',
      '/matching/best/10.jpg',
    ],
    imageStyle: Array(10).fill('wide'),
    descriptions: [],
    multiSelect: 2,
    pauseBetween: 1,
    options: Array(10).fill(['A', 'B', 'C', 'D']),
    solution: [
      ['A', 'B'],
      ['C', 'D'],
      ['B', 'C'],
      ['A', 'D'],
      ['C', 'D'],

      ['A', 'D'],
      ['B', 'C'],
      ['A', 'B'],
      ['C', 'D'],
      ['B', 'D'],
    ],
    showSolution: false,
    scoring: 'multiSelectScoring',

    resultsSystem: {
      eventId: 'e010',
      stageId: 's002',
    },
    saveResult: true,
  },

  {
    name: 'The Maze',
    tagline: 'Stage 3',
    description: 'Can You Navigate Around The Maze?',
    location: 'maze',
    instructions: [
      'Navigate your way around a course in a maze, as quickly as possible.',
      'Use the Up/Down arrows to move forwards and backwards, Left/ Right to rotate the view, the Space bar toggles the view of the map. The compass in the bottom right always points north. Full controls below.',
      'Based on Laby: https://routegadget.net/laby by Jarkko Ryyppö',
      'The Maze may take a second to load (especially with a slow internet connection) as it is building a full 3D model, please be patient - it should load. Once the maze appears (It has blue walls), everything should be loaded, and nothing else needs to download',
      "Note: The Random practice courses generates a new maze on each reload, it's totally random - not guaranteed to be possible to complete",
      'REMEMBER TO CLICK THE `Finish` BUTTON AFTER YOU HAVE FINISHED TO UPLOAD YOUR RESULT',
    ],
    gameButtons: [
      { location: '/unlocked/game/maze/play', name: 'Start Game (Easier)' },
      {
        location: '/unlocked/game/maze-hard/play',
        name: 'Start Game (Harder)',
      },
    ],

    lockdown: true,
    recommendedGames: [10, 8],
    scoring: 'timeTaken',
    scoreIsTime: true,
    noCountdown: true,
    resultsSystem: {
      eventId: 'e010',
      stageId: 's003',
      course: 'Course B',
    },
    extraPractice: [
      {
        button: 'Random Practice Game (Easier)',
        location: 'random20',
      },

      { button: 'Random Practice Game (Harder)', location: 'random40' },
    ],
    saveResult: true,
    imageStyle: ['maze'],
    images: ['maze'],
    mazeSettings: {
      rows: [
        [1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 0, 0, 1],
        [1, 0, 1, 0, 0, 0, 1, 1, 0, 1, 0, 1, 0, 0, 0, 0, 1, 0, 0],
        [1, 1, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 0, 1, 0, 1, 1],
        [1, 0, 1, 1, 0, 1, 1, 0, 1, 1, 1, 0, 1, 1, 0, 0, 1, 1, 0],
        [0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 1, 0, 0, 1, 0, 1, 0, 1, 0],
        [0, 1, 0, 0, 0, 1, 0, 1, 1, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1],
        [0, 0, 0, 0, 1, 0, 0, 1, 0, 1, 1, 1, 0, 0, 0, 1, 1, 1, 1],
        [1, 1, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0],
        [1, 0, 0, 0, 0, 0, 1, 1, 0, 1, 0, 0, 0, 1, 1, 0, 1, 0, 0],
        [1, 1, 0, 0, 1, 1, 0, 1, 0, 1, 1, 1, 0, 0, 0, 0, 1, 1, 0],
        [0, 0, 1, 1, 0, 0, 0, 0, 0, 1, 0, 1, 0, 0, 1, 0, 1, 1, 1],
        [1, 0, 0, 0, 1, 0, 1, 1, 0, 0, 1, 1, 1, 1, 0, 0, 1, 1, 0],
        [1, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0],
        [0, 0, 1, 0, 1, 0, 0, 1, 1, 1, 0, 1, 0, 0, 1, 0, 0, 1, 0],
        [1, 0, 1, 0, 1, 1, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 1],
        [1, 0, 1, 0, 1, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0],
        [0, 0, 1, 0, 0, 1, 1, 0, 1, 0, 0, 1, 1, 1, 1, 1, 0, 0, 0],
        [1, 0, 1, 0, 1, 0, 0, 1, 1, 0, 1, 1, 0, 0, 1, 1, 1, 0, 0],
        [1, 0, 0, 1, 0, 0, 1, 1, 0, 0, 1, 0, 1, 1, 0, 0, 0, 0, 0],
        [1, 0, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1],
      ],
      columns: [
        [1, 1, 0, 0, 1, 1, 1, 1, 1, 1, 0, 1, 1, 0, 1, 1, 1, 0, 1, 1],
        [1, 1, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 1, 1, 1, 1],
        [1, 1, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 0, 1, 0, 1, 1, 0, 1, 1],
        [1, 0, 1, 1, 0, 0, 1, 0, 1, 0, 0, 0, 1, 1, 1, 0, 1, 0, 0, 1],
        [1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 1, 0, 1, 1, 0, 0, 0, 1, 1],
        [1, 1, 1, 1, 0, 1, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1],
        [1, 1, 1, 0, 0, 0, 0, 1, 0, 0, 1, 1, 1, 1, 1, 0, 0, 1, 0, 0],
        [0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1],
        [1, 0, 0, 1, 0, 0, 0, 0, 0, 1, 1, 0, 0, 1, 0, 0, 0, 1, 0, 1],
        [0, 0, 1, 0, 1, 1, 0, 1, 1, 1, 1, 0, 1, 0, 0, 0, 0, 1, 1, 1],
        [1, 0, 1, 0, 0, 1, 1, 0, 1, 0, 1, 0, 0, 0, 1, 0, 0, 1, 1, 1],
        [1, 0, 0, 1, 0, 1, 1, 0, 1, 0, 0, 0, 0, 1, 0, 1, 1, 1, 0, 1],
        [1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 1, 1, 0, 1, 1, 0, 0, 0, 1, 0],
        [1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 1, 0, 1, 0, 0, 1, 1],
        [1, 1, 1, 0, 1, 0, 1, 0, 0, 0, 1, 1, 0, 0, 0, 0, 1, 0, 1, 1],
        [1, 0, 1, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1],
        [1, 1, 0, 1, 1, 1, 1, 1, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 0, 1],
        [1, 0, 1, 1, 0, 1, 1, 0, 0, 1, 0, 1, 1, 1, 0, 0, 0, 0, 0, 1],
        [1, 0, 0, 0, 0, 1, 1, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1, 1, 0, 1],
      ],
      startLocation: [1, 18],

      controls: [
        { position: [5, 12] },
        { position: [5, 3] },
        { position: [14, 7] },
      ],
    },
  },

  {
    hidden: true,
    name: 'The Maze - Hard',
    tagline: 'Stage 3',
    description: 'Can You Navigate Around The Maze?',
    location: 'maze-hard',
    instructions: [
      'Navigate your way around a course in a maze, as quickly as possible.',
      'Use the Up/Down arrows to move forwards and backwards, Left/ Right to rotate the view, the Space bar toggles the view of the map. The compass in the bottom right always points north. Full controls below.',
      'Based on Laby: https://routegadget.net/laby by Jarkko Ryyppö',
      'The Maze may take a second to load (especially with a slow internet connection) as it is building a full 3D model, please be patient - it should load. Once the maze appears (It has blue walls), everything should be loaded, and nothing else needs to download',
      "Note: The Random practice courses generates a new maze on each reload, it's totally random - not guaranteed to be possible to complete",
      'REMEMBER TO CLICK THE `Finish` BUTTON AFTER YOU HAVE FINISHED TO UPLOAD YOUR RESULT',
    ],
    gameButtons: [
      { location: '/unlocked/game/maze/play', name: 'Start Game (Easier)' },
      {
        location: '/unlocked/game/maze-hard/play',
        name: 'Start Game (Harder)',
      },
    ],
    extraPractice: [
      { button: 'Random Practice Game (Easier)', location: 'random20' },

      { button: 'Random Practice Game (Harder)', location: 'random40' },
    ],

    lockdown: true,
    recommendedGames: [10, 8],
    scoring: 'timeTaken',
    scoreIsTime: true,
    noCountdown: true,
    resultsSystem: {
      eventId: 'e010',
      stageId: 's003',
      course: 'Course A',
    },
    saveResult: true,
    imageStyle: ['maze'],
    images: ['maze'],
    mazeSettings: {
      rows: [
        '111111011111111111111111111111111111111',
        '001001100101001000001000100111011001110',
        '100101011111100000101101010011011011101',
        '111111011001000110100100111011001100001',
        '100001100000000000110100110011110001010',
        '110111111101011101000000101001001100011',
        '001001000110100110000001001101001110100',
        '011011001000111100101010000000111011100',
        '111110110101011100101010111011000111001',
        '101000000100000110011000010111110101100',
        '001011001001010001100111001001011110000',
        '001110111110011100110011101000100111000',
        '010010101001011111011001001100110001111',
        '101001001000000010000001100001001101011',
        '000001000110110000100011011101101101000',
        '110110101100010011101101011001111100000',
        '101101001101000011110110111111011111100',
        '100101101001000101010011000001011100000',
        '100110001011100001000100111101001011111',
        '001111101000100110110101010000100000111',
        '011100110100110001101000100111111100000',
        '000110010010011111100111101000000001110',
        '010010000111101001100101000000000100110',
        '101100110110000111111001101111001010101',
        '110111010111011001110000011001001001110',
        '111000111100011101010110110111101101011',
        '011010001000111101001100101110101001111',
        '100000010010110100000111000111101010001',
        '001100011001010100111010001100110100000',
        '000111100001000010001001000101000111110',
        '010011001000100111111110001011101011101',
        '001111011001010101001000011110011100101',
        '011000001100101001111001101100001111001',
        '001001011011110111010101111010100110100',
        '000101110000011100010110100100110011000',
        '111000100111010101110001011111101000000',
        '011000101010111001010000101001011101010',
        '001101110100101000010010110110101101111',
        '100100001001100100001000000011100110001',
        '111110111111111111111111111111101111111',
      ].map((row) => [...row].map(Number)),
      columns: [
        '1101100000010010001001110110000110110101',
        '1111000101001011101110011000010111100101',
        '1000001000101100101001100101010100110111',
        '1001100100101000101111010110010100011101',
        '1110110001001010110100010011110101001111',
        '1000000101001000001101011000000001000100',
        '1111011010000011000010101100001100100001',
        '1101100010100100100010000001010000001001',
        '1100000010100001000100000100001000010001',
        '1101000100011010110010101100100001111101',
        '1010100000000100010010100010001000101111',
        '1100000110000011000101100100011001010101',
        '1000000000111000011000011000011010110101',
        '1000001000001001000011010010000110010001',
        '1000010000000010000100000110011010100111',
        '1101111000000100000100000011000000101111',
        '1011001101010010111000100101000110000011',
        '1101100111001011001110000000100100000001',
        '1111000101101100011100110000010110000111',
        '1000101101101110010011011001100110010001',
        '1010000011010101101001001100011000000101',
        '1101011111011000111100000001110000000001',
        '1010010010100101110100001111100101100101',
        '1110001011111000100010100100100101101101',
        '1001110000010000111010010000010100100100',
        '1100101100100100010001001100110011010111',
        '1000010000001010110101000010010000001101',
        '1010000011000000101100000101001010111101',
        '1010100010011110001010011011000010001011',
        '1001101111110011111011110000001101000001',
        '1100100101000101000010000000110111111001',
        '1000001001000001010000001110101110100011',
        '0011101000111011000100110101001000001111',
        '1010001110001000000000110110110000011000',
        '1000100000000100011000000000000110001101',
        '1101100000011011000100011010101100010011',
        '1011100000000111010111000000100000001001',
        '1101000001011011000000101110101001000111',
        '1011110010100100011001101000010001010011',
      ].map((row) => [...row].map(Number)),
      startLocation: [16, 37],
      controls: [
        { position: [12, 30] },
        { position: [5, 2] },
        { position: [23, 4] },
        { position: [32, 16] },
      ],
    },
  },

  {
    name: 'Trail O',
    tagline: 'Stage 4',
    description:
      'Pick the Correct Flag! - Pick Which Flag Matches the Control on the Map',
    location: 'trailo',
    instructions: [
      'Which control flag/marker in the photo matches the one on the map?',
      'You see controls A, B, C, D, E and F. You must chose the one that matches the map. If you think none match the map pick Z.',
      'You will be ranked by time you took. If you get a question wrong then you get a 30 second penalty.',
      'If you hover over the image you can use a magnifier.',
    ],
    recommendedGames: [2, 4],
    lockdown: true,
    practice: 'Japan',

    resultsSystem: {
      eventId: 'e010',
      stageId: 's004',
    },

    images: [
      `/trailo/comp/T-1.jpg`,
      `/trailo/comp/T-2.jpg`,
      `/trailo/comp/T-3.jpg`,
      `/trailo/comp/T-4.jpg`,
      `/trailo/comp/T-5.jpg`,

      `/trailo/comp/T-16.jpg`,
      `/trailo/comp/T-17.jpg`,
      `/trailo/comp/T-18.jpg`,
      `/trailo/comp/T-19.jpg`,
      `/trailo/comp/T-20.jpg`,

      '/trailo/june/4-1.jpg',
      '/trailo/june/4-2.jpg',
      '/trailo/june/4-3.jpg',
      '/trailo/june/4-4.jpg',
      '/trailo/june/4-5.jpg',

      '/trailo/british/2-2.jpg',
      '/trailo/british/2-1.jpg',
      '/trailo/british/2-3.jpg',
      '/trailo/british/2-4.jpg',
      '/trailo/british/2-5.jpg',

      '/trailo/british/5-1.jpg',
      '/trailo/british/5-4n.png',
      '/trailo/british/5-3.jpg',
      '/trailo/british/5-4n.jpg',
      '/trailo/british/5-5.jpg',
    ],
    imageStyle: Array(25).fill('wide'),
    descriptions: [],
    options: Array(25).fill(['A', 'B', 'C', 'D', 'E', 'F', 'Z']),
    solution: [
      ...['E', 'A', 'F', 'C', 'Z'],
      ...['E', 'Z', 'C', 'D', 'F'],
      ...['F', 'E', 'A', 'B', 'D'],
      ...['A', 'F', 'B', 'D', 'E'],
      ...['E', 'C', 'F', 'Z', 'D'],
    ],
    showSolution: false,
    pauseBetween: 5,
    enableMagnifier: true,
    scoring: 'penaltyScoring',
    scoreIsTime: true,
    penalty: 30,
    magnifierSize: 200,
    saveResult: true,
  },
  {
    name: 'Photo Memory O',
    tagline: 'Stage 5',
    description:
      'Remember the Map! Choose Which Photo Matches the Map Segment You Have Just Seen',
    location: 'photomemory',
    instructions: [
      'You’ll see a map with a control and the direction that you’re approaching the control from (shown as an arrow). Then, on the next screen, there are 4 photos. You need to choose which photo matches the map you just saw. You can’t go back to the map again.',
      'You are scored on how many you got right and then by the time you took to decide',
    ],
    recommendedGames: [3, 5],
    lockdown: true,
    practice: 'MineWoods',

    showSolution: false,
    pauseBetween: 2,
    skipButton: false,
    newPuzzleEvery: 2,
    scoring: 'defaultScoring',

    images: [
      '/memory/comp/n1.jpg',
      '/memory/comp/n2.jpg',
      '/memory/comp/n3.jpg',
      '/memory/comp/n4.jpg',
      '/memory/comp/n5.jpg',
      '/memory/comp/n6.jpg',
      '/memory/comp/n7.jpg',
      '/memory/comp/n8.jpg',
      '/memory/comp/n9.jpg',
      '/memory/comp/n10.jpg',
      '/memory/junior/11.jpg',
      '/memory/junior/12.jpg',
      '/memory/junior/13.jpg',
      '/memory/junior/14.jpg',
      '/memory/junior/15.jpg',
      '/memory/junior/16.jpg',
      '/memory/junior/17.jpg',
      '/memory/junior/18.jpg',
      '/memory/junior/19.jpg',
      '/memory/junior/20.jpg',
    ],
    imageStyle: Array(10).fill(['tall', 'tall']).flat(),
    descriptions: [],
    options: Array(10)
      .fill([['Go'], ['A', 'B', 'C', 'D']])
      .flat(),
    solution: ['B', 'C', 'D', 'A', 'C', 'C', 'D', 'A', 'C', 'A'],

    resultsSystem: {
      eventId: 'e010',
      stageId: 's005',
    },
    saveResult: true,
  },
  {
    name: 'Ski-O Map Memory',
    tagline: 'Stage 7',
    description:
      'Remember the Map, Choose the Right Direction at The Junctions',
    location: 'map-memory',
    instructions: [
      'Remember the Map, Choose the Right Direction at The Junction.',
      'You see a map, and you have to remember the route between the start and the control. You then have to choose which way to go at each junction.',
      'There is a 30s time penalty after starting for looking at the map.',
      'For people who have motion sickness or dislike animated content, a reduced motion alternative is avaliable, it will not effect scoring which version you choose',
      'Based on the Ski O game: http://catchingfeatures.com/b/skiomapmemory.html',
    ],
    lockdown: true,
    recommendedGames: [8, 11],
    scoring: 'anyAnswer',
    noCountdown: true,
    resultsSystem: {
      eventId: 'e010',
      stageId: 's007',
    },

    extraPractice: [
      { button: 'Practice Game (Easy)', location: 'easy' },
      {
        button: 'Practice Game (Easy) [Reduced Motion] ',
        location: 'easy?reducedMotion=true',
      },
      { button: 'Practice Game (Hard)', location: 'hard' },
      {
        button: 'Practice Game (Hard) [Reduced Motion]',
        location: 'hard?reducedMotion=true',
      },
    ],
    map: 'hallglen',
    saveResult: true,
    imageStyle: Array(10).fill('mapMemory'),
    images: [
      { start: 3, finish: 0 },
      { start: 50, finish: 42 },
      { start: 33, finish: 10 },
      { start: 56, finish: 23 },
      { start: 30, finish: 14 },
      { start: 2, finish: 80 },
      { start: 7, finish: 29 },
      { start: 26, finish: 79 },

      { start: 42, finish: 67 },
      { start: 60, finish: 6 },
    ],
    extraButtons: [
      {
        location: '/unlocked/game/map-memory/play?reducedMotion=true',
        name: 'Start Game (Reduced Motion)',
      },
    ],
  },
].map((game) => ({ ...game, closed: true }))
